import React from 'react';

const BCIndustryGroupFormModal = React.lazy(() => import('../components/FormModal'));
const bCIndustryGroupModalRegistry = {
    company_bcIndustryGroupId: BCIndustryGroupFormModal
};
export default bCIndustryGroupModalRegistry;
